import gql from 'graphql-tag';

const spreadsheetUpload = gql`
  mutation spreadsheetUpload($input: SpreadsheetUploadInput!) {
    spreadsheetUpload(input: $input) {
      file_id
      upload_url
    }
  }
`;

export default spreadsheetUpload;
